import { render, staticRenderFns } from "./StoryViewer.vue?vue&type=template&id=0cdcdb6a&scoped=true&"
import script from "./StoryViewer.vue?vue&type=script&lang=js&"
export * from "./StoryViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdcdb6a",
  null
  
)

export default component.exports